import clsx from 'clsx'
import classes from './AnimatedBackgorund.module.css'
//import patternImg from './pattern.png'

interface AnimatedBackgroundProps {
  radial?: boolean
  opacity?: number
}

export function AnimatedBackground({
  radial,
  opacity = 0.6,
}: AnimatedBackgroundProps) {
  const cls = clsx(classes.wrap, { [classes.radial]: radial })

  return (
    <div className={cls}>
      <div
        style={{
          //backgroundImage: `url(${patternImg})`,
          backgroundRepeat: 'repeat',
          backgroundSize: 'auto',
          opacity: opacity,
          width: '100%',
          height: '100%',
        }}
      />
    </div>
  )
}
